import React, { useEffect, useState } from 'react';
import { Button, Form, DatePicker, Select, Space, Alert, message } from 'antd';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import { GetMonitorSensor, GetHisReading, GetHisLevelConsumtion } from '../../../Api/getData';

const { RangePicker } = DatePicker;

const FilterTanggal = ({ dataFilter, accountName, sensorName, startRanges, endRanges, TimesRanges }) => {

    const [showAlert, setShowAlert] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [loadingss, setLoadingss] = useState(false);
    const [activeFilter, setActiveFilter] = useState(null);

    const [form] = Form.useForm();

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [sensorList, setSensorList] = useState([]);

    useEffect(() => {
        const fetchGetMonitorSensor = async () => {
            const response = await GetMonitorSensor(
                {
                    AccountId: KodeCabang,
                    ObjectCode: ShipCode
                }
            );
            setSensorList(response);
        }
        fetchGetMonitorSensor();
    }, []);

    // Initial load data on mount
    useEffect(() => {
        const loadInitialData = async () => {
            if (startRanges && endRanges) {
                const sensorCode = sensorName && sensorName.length > 0 && sensorName[0] === 'All' ? '' : (sensorName && sensorName.length > 0 ? sensorName.join(',') : '');

                try {
                    setLoadings(true);
                    dataFilter({ isLoading: true });

                    const response = await GetHisReading({
                        AccountId: KodeCabang,
                        ObjectCode: ShipCode,
                        SensorCode: sensorCode,
                        StartDate: startRanges,
                        EndDate: endRanges,
                        Time: TimesRanges
                    });

                    const responseLevel = await GetHisLevelConsumtion({
                        AccountId: KodeCabang,
                        ObjectCode: ShipCode,
                        StartDate: startRanges,
                        EndDate: endRanges
                    });

                    const processedData = {
                        dataSource: response,
                        dataEngine1: response.filter((item) => (item.DisplayNo === 2 || item.DisplayNo === 3)),
                        dataEngine2: response.filter((item) => (item.DisplayNo === 4 || item.DisplayNo === 5)),
                        dataFuelLevel: response.filter((item) => (item.SensorCode?.startsWith("LVL"))),
                        dataInclination: response.filter((item) => (item.SensorCode?.startsWith("INC"))),
                        dataLevelConsumption: responseLevel.filter((item) => (item.DisplayNo === 20)),
                        filterParams: {
                            sensor: sensorName,
                            startDate: startRanges,
                            endDate: endRanges,
                            TimeRange: TimesRanges
                        },
                        isLoading: false
                    };

                    dataFilter(processedData);
                } catch (error) {
                    dataFilter({ isLoading: false });
                } finally {
                    setLoadings(false);
                }
            }
        };

        loadInitialData();
    }, []);


    const onFinish = async (values) => {
        setLoadings(true);

        const { RangeDate, Time, Sensor } = values;
        const start = dayjs(RangeDate[0]);
        const end = dayjs(RangeDate[1]);
        const durationInHours = end.diff(start, 'hour', true);

        if (Time === '5' || Time === '10') {
            // Untuk interval 5 dan 10 menit, batasi maksimal 24 jam
            if (durationInHours > 24) {
                message.error(`For Time ${TimesRanges} Minute, the date range cannot exceed 24 hours.`);
                setLoadings(false);
                return;
            }
        }

        // Simulate a 1.5-second delay
        await new Promise((resolve) => setTimeout(resolve, 1500));

        const formatDateTime = (isoDateString) => {
            return dayjs(isoDateString).format('YYYY-MM-DD HH:mm:ss.SSS');
        }

        const startDateRange = RangeDate ? formatDateTime(RangeDate[0]) : startRanges;
        const endDateRange = RangeDate ? formatDateTime(RangeDate[1]) : endRanges;

        const sensorCode = Sensor && Sensor.length > 0 && Sensor[0] === 'All' ? '' : (Sensor && Sensor.length > 0 ? Sensor.join(',') : '');

        try {
            // Notify parent that loading started
            dataFilter({ isLoading: true });

            // Fetch HisReading data
            const response = await GetHisReading({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                SensorCode: sensorCode,
                StartDate: startDateRange,
                EndDate: endDateRange,
                Time: Time
            });

            // Fetch Level Consumption data
            const responseLevel = await GetHisLevelConsumtion({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: startDateRange,
                EndDate: endDateRange
            });

            // Process data
            const processedData = {
                dataSource: response,
                dataEngine1: response.filter((item) => (item.DisplayNo === 2 || item.DisplayNo === 3)),
                dataEngine2: response.filter((item) => (item.DisplayNo === 4 || item.DisplayNo === 5)),
                dataFuelLevel: response.filter((item) => (item.SensorCode?.startsWith("LVL"))),
                dataInclination: response.filter((item) => (item.SensorCode?.startsWith("INC"))),
                dataLevelConsumption: responseLevel.filter((item) => (item.DisplayNo === 20)),
                filterParams: {
                    sensor: Sensor,
                    startDate: startDateRange,
                    endDate: endDateRange,
                    TimeRange: Time
                },
                isLoading: false
            };

            dataFilter(processedData);

            setShowAlert(true);
        } catch (error) {
            dataFilter({ isLoading: false });
        } finally {
            setLoadings(false);
        }
    };

    const onReset = async () => {
        setLoadingss(true);

        // Reset the form fields
        form.resetFields();

        // Simulate a 2-second delay
        // await new Promise((resolve) => setTimeout(resolve, 2000));

        // Reload the page
        window.location.reload();

        setLoadingss(false);
    };

    const messageAlert = `From ${startRanges} - ${endRanges} / ${TimesRanges} Minute, ${sensorName}`;

    const handleSensorChange = (value) => {
        // Jika value kosong atau null, reset ke array kosong
        if (!value || value.length === 0) {
            form.setFieldsValue({
                Sensor: [],
            });
            return;
        }

        // Dapatkan nilai terakhir yang dipilih
        const lastSelected = value[value.length - 1];

        // Jika yang terakhir dipilih adalah "All"
        if (lastSelected === 'All') {
            // Set hanya "All" dan hapus semua sensor lain
            setTimeout(() => {
                form.setFieldsValue({
                    Sensor: ['All'],
                });
            }, 0);
        } else {
            // Jika yang terakhir dipilih adalah sensor lain, hapus "All" dari selection
            const filteredValue = value.filter(item => item !== 'All');
            setTimeout(() => {
                form.setFieldsValue({
                    Sensor: filteredValue,
                });
            }, 0);
        }
    };

    const handleFilterClick = async (filterType) => {
        setActiveFilter(filterType);
        const now = dayjs();
        let startDate, endDate;

        switch (filterType) {
            case 'today':
                startDate = now.startOf('day');
                endDate = now.endOf('day');
                break;
            case 'weekly':
                startDate = now.startOf('week');
                endDate = now.endOf('week');
                break;
            case 'monthly':
                startDate = now.startOf('month');
                endDate = now.endOf('month');
                break;
            default:
                return;
        }

        // Get current Time value, ensure minimum is 15
        const currentTime = form.getFieldValue('Time') || TimesRanges || '15';
        const timeValue = parseInt(currentTime) >= 15 ? currentTime : '15';

        // Get current Sensor value
        const currentSensor = form.getFieldValue('Sensor') || sensorName || [];

        // Set form values
        form.setFieldsValue({
            RangeDate: [startDate, endDate],
            Time: timeValue,
            Sensor: currentSensor,
        });

        // Wait a bit for form to update, then submit
        setTimeout(async () => {
            const values = form.getFieldsValue();
            await onFinish(values);
        }, 100);
    };

    return (
        <Space
            direction="vertical"
            style={{
                width: '100%',
            }}
        >
            {showAlert === true ?
                <Alert message={messageAlert} type="info" showIcon />
                :
                <></>
            }
            <Form
                layout="inline"
                onFinish={onFinish}
                form={form}
                initialValues={{
                    'RangeDate': [dayjs(startRanges), dayjs(endRanges)],
                    'Time': TimesRanges,
                    'Ship': accountName,
                    'Sensor': sensorName,
                }}
            >
                <div className="flex w-full flex-col justify-center gap-4">
                    <div className="w-full flex flex-col lg:flex-row gap-4 lg:gap-2 lg:items-center justify-center">
                        <div className="flex gap-2">
                            <Button
                                type={activeFilter === 'today' ? 'primary' : 'default'}
                                onClick={() => handleFilterClick('today')}
                                loading={activeFilter === 'today' && loadings}
                            >
                                Today
                            </Button>
                            <Button
                                type={activeFilter === 'weekly' ? 'primary' : 'default'}
                                onClick={() => handleFilterClick('weekly')}
                                loading={activeFilter === 'weekly' && loadings}
                            >
                                Weekly
                            </Button>
                            <Button
                                type={activeFilter === 'monthly' ? 'primary' : 'default'}
                                onClick={() => handleFilterClick('monthly')}
                                loading={activeFilter === 'monthly' && loadings}
                            >
                                Monthly
                            </Button>
                        </div>

                        <Form.Item
                            name="RangeDate"
                        >
                            <RangePicker
                                showTime={{
                                    format: 'HH:mm',
                                }}
                                format="YYYY-MM-DD HH:mm"
                                onChange={() => setActiveFilter(null)}
                            />
                        </Form.Item>

                        <Form.Item
                            name="Time"
                        >
                            <Select
                                options={[
                                    {
                                        value: '5',
                                        label: '5 minute',
                                    },
                                    {
                                        value: '10',
                                        label: '10 minute',
                                    },
                                    {
                                        value: '15',
                                        label: '15 minute',
                                    },
                                    {
                                        value: '30',
                                        label: '30 minute',
                                    },
                                    {
                                        value: '45',
                                        label: '45 minute',
                                    },
                                    {
                                        value: '60',
                                        label: '60 minute',
                                    },
                                ]}
                            />
                        </Form.Item>

                        <Form.Item
                            className="lg:min-w-40"
                            name="Sensor"
                        >
                            <Select
                                allowClear
                                mode="multiple"
                                dropdownStyle={{
                                    width: '300px',
                                }}
                                style={{
                                    maxWidth: '300px',
                                }}
                                placeholder="Select Sensor"
                                options={
                                    [
                                        {
                                            value: 'All',
                                            label: 'All',
                                            emoji: '🔍',
                                            desc: 'All Sensor'
                                        },
                                        ...sensorList.map((item) => ({
                                            value: item.SensorId,
                                            label: item.SensorId,
                                            emoji: item.SensorName,
                                            desc: item.SensorId
                                        }))
                                    ]}
                                onChange={handleSensorChange}
                                onDeselect={(value) => {
                                    const currentValues = form.getFieldValue('Sensor') || [];
                                    const newValues = currentValues.filter(item => item !== value);
                                    form.setFieldsValue({
                                        Sensor: newValues,
                                    });
                                }}
                                optionRender={option => (
                                    <Space>
                                        <span role="img" aria-label={option.data.desc}>
                                            {option.data.emoji}
                                        </span>
                                        <p className="text-sm font-semibold">({option.data.desc})</p>
                                    </Space>
                                )}
                            />
                        </Form.Item>

                    </div>

                    <div className="flex w-full justify-end">
                        <Form.Item>
                            <Space>
                                <Button htmlType="button" onClick={onReset} loading={loadingss} style={{ backgroundColor: "#FFFFFF" }}>
                                    Reset
                                </Button>
                                <Button type="primary" htmlType="submit" loading={loadings}>
                                    Submit
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>

                </div>
            </Form>

        </Space>
    )
}

export default FilterTanggal;
